export const instantRedeemlevelsAcelevel=
 [
    {
        "aceLevel": "platinum+",
        "instantRedeemsPerMonth": "20",
        "maxAmountPerRequest": "5000"
    },
    {
        "aceLevel": "platinum",
        "instantRedeemsPerMonth": "20",
        "maxAmountPerRequest": "5000"
    },
    {
        "aceLevel": "gold",
        "instantRedeemsPerMonth": "12",
        "maxAmountPerRequest": "5000"
    },
    {
        "aceLevel": "silver",
        "instantRedeemsPerMonth": "8",
        "maxAmountPerRequest": "2000"
    },
    {
        "aceLevel": "bronze",
        "instantRedeemsPerMonth": "5",
        "maxAmountPerRequest": "1000"
    }
]
